import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import ArrowDown from '@/images/arrows/ArrowDown.svg';
import ArrowUp from '@/images/arrows/ArrowUp.svg';
import theme from '@/theme';
import styled from '@emotion/styled';
import { Typography } from '@mui/material';

export const StyledText = styled(Typography)`
    color: ${({ theme }) => theme.colors.secondary[700]};
    font-family: ${({ theme }) => theme.fonts.primary};
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    letter-spacing: -0.28px;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    :hover {
        ${StyledText} {
            color: ${theme.colors.secondary.main};
        }

        svg {
            background-color: ${theme.colors.secondary.main};
        }
    }
`;

interface Props {
    text: string;
    show: boolean;
    setShow: any;
    className?: string;
}

export const SectionTitle = ({ text, show, setShow, className }: Props) => {
    return (
        <Container className={className} onClick={() => setShow(!show)}>
            <StyledText>{text}</StyledText>
            <MaskedIcon src={show ? ArrowDown : ArrowUp} size="24px" color={theme.colors.black[500]} />
        </Container>
    );
};
